import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[roleCheck]',
  standalone: true
})
export class RoleBasedAccessDirective implements OnChanges{

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() roleCheck!: string[];
  @Input() roleCheckCurrentRole!: string;

  ngOnChanges() {
    if (this.roleCheck.includes(this.roleCheckCurrentRole)) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
